import { Schema } from "@ext/markdown/core/render/logic/Markdoc";

export const br: Schema = { render: "Br" };
